
  <script>
  
  import Layout from "../../layouts/main";
  import GiftCardApi from "@/services/gift-card-api";

  
  export default ({
    name: "success-paiment",
    components: {
      Layout, 
    },
  
  
    data() {
        return {
          giftCard:{name:'' , mail:'' ,confirmationMailReceiver:'' , mailReceiver:'' , nameReceiver:'' , amount:0 ,message:'' , status:false , amountAsString:''},
        }
    },

    props: {
      orderId:{
            type: String,
            default:null
          },
    },
  

    mounted(){
    this.getGiftCard()
    },
    watch:{
      orderId: function(){
        if(this.orderId && this.orderId.length ){
        this.getGiftCard()
      }
      }
    },
  
    methods: {
      getGiftCard(){
        if(!this.orderId){
          return
        }
        GiftCardApi.getGiftCard(this.orderId).then((result)=>{
          if(result){
            this.giftCard = result
          }
        })
      },
  
    }
  })
  </script>

<template>
    <Layout>

        <div v-if="giftCard.paymentDate" class="payment-card"> 
          <div class="card-body">
            <div class="row" >
            <div class="col-lg-6 col-sm-12 p-2 text-center mx-auto " style=" align-content: center;  ">
              <div class="text-warning font-weight-bold  payment-header">Félicitations pour votre achat !</div>
              <div class="text-dark font-size-22 mb-2">Votre bon d'achat a été payé avec succès.</div>
              <div class="text-dark font-size-22 mb-2"> Bon d'achat de montant <strong>{{ this.giftCard.amountAsString }}</strong>  a été envoyée à <strong>{{ this.giftCard.nameReceiver }}</strong> </div>
              <div class="text-dark font-size-18 font-weight-bold mt-3 mb-2">Merci pour votre achat !</div>
              <div class="text-dark font-size-18 font-weight-bold mb-2">Nous sommes heureux que vous ayez choisi <strong>HA</strong></div>

                <div class="pr-md-2 text-center mt-4">
                  <a href="/">
                    <b-button variant="outline-dark"  class="mb-3 font-size-16 "  style="min-width: 160px"  >
                      Revenir à la page d'accueil
                    </b-button>
                  </a>
                </div>            
            </div>
            <div class="col-lg-6 col-sm-12 text-center p-2"  style=" align-content: center;">
            <img class="image-container img-fluid" alt="" src="../../../assets/images/HA02.jpg" />
        </div>
          </div> 
          </div>
        </div>
    </Layout>
  </template>
          
          
          
  <style scoped>

  /* Web view */
  @media only screen and (min-width: 601px) {
    .pageHeader {
      padding-top: 4%;
    }
  }
  
  /* Mobile view */
  @media only screen and (max-width: 600px) {
    .pageHeader {
      padding-top: 15%;
    }
  }

  .image-container{
    border-radius: 15px;
    border: 1px solid #bbbaba;
    padding: 0px; 
    display: inline-block; 
  }

  .payment-card {

    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 20px;
    margin: 3% 5% 0 5%;
    position: relative;
    overflow: hidden;
}

.payment-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4); 
}

.payment-header{
  font-size: 40px;
  padding: 15px 0;
}
  </style>